<template>
    <div>
        <el-breadcrumb style="float: right" separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">{{$t('route.home')}}</el-breadcrumb-item>
            <el-breadcrumb-item>{{$t('route.documents')}}</el-breadcrumb-item>
        </el-breadcrumb>

        <h2 class="page-title"> {{$t('entities.document.plural')}} </h2>

        <el-row :gutter="20">
            <el-col :xs="24" :md="8">
                <el-form @submit.native.prevent class="search" :inline="true">
                    <el-form-item>
                        <el-input v-model="pager.search" :placeholder="$t('table.search')">
                            <el-button slot="append" icon="el-icon-search"></el-button>
                        </el-input>
                    </el-form-item>
                </el-form>
            </el-col>

            <el-col class="button-group" :xs="24" :md="16">
                <el-button
                    v-if="hasRoleToCreate"
                    icon="el-icon-fa-file-o"
                    @click="create()"
                    type="primary"
                >{{$t('table.add')}}</el-button>
            </el-col>
        </el-row>
        <!-- ************************** -->
        <!-- *                        * -->
        <!-- *  Club import data      * -->
        <!-- *                        * -->
        <!-- ************************** -->
        <transition name="fade" mode="out-in">
            <router-view name="documentImport"></router-view>
        </transition>

        <el-table
            :data="pager.paginate(list)"
            :default-sort="{
                prop: 'name',
                order: 'ascending'
            }"
            @row-click="rowClick"
            empty-text="There are no documents yet"
            @sort-change="(args) => pager.sortChange(args)"
            style="width: 100%"
            v-loading="loading"
            border
        >
            <el-table-column prop="name" :label="$t('entities.document.prop.name')" sortable="custom"></el-table-column>
            <el-table-column
                prop="attachments"
                :label="$t('entities.document.singular')"
            >
                <template slot-scope="scope">
                     <app-file-link-list :files=" scope.row.attachments" />
                <!-- <div
                    v-for="attachment in scope.row.attachments"
                    :key="attachment.name"
                >
                    {{ attachment.name }}
                </div> -->
                </template>
            </el-table-column>
            <el-table-column
                v-if="hasRoleToReadLogs"
                prop="modified"
                :label="$t('status.modifiedAt')"
                sortable="custom"
            >
                <template slot-scope="scope">{{ scope.row.modified | formatDatetime }}</template>
            </el-table-column>

            <el-table-column
                v-if="hasRoleToReadLogs"
                prop="created"
                :label="$t('status.created')"
                sortable="custom"
            >
                <template slot-scope="scope">{{ scope.row.created | formatDatetime }}</template>
            </el-table-column>

            <!-- ************************** -->
            <!-- *                        * -->
            <!-- *         Actions        * -->
            <!-- *                        * -->
            <!-- ************************** -->
            <el-table-column
                :fixed="isMobile? undefined : 'right'"
                align="center"
                :label="$t('table.actions')"
                width="160"
            >
                <template slot-scope="scope">
             
                    <el-tooltip v-if="hasRoleToRead" :content="$t('table.details')" placement="top">
                        <el-button
                            icon="el-icon-fa-search"
                            size="small"
                            type="text"
                            @click="show(scope.row.id)"
                        />
                    </el-tooltip>

                    <el-tooltip v-if="hasRoleToUpdate" :content="$t('table.edit')" placement="top">
                        <el-button
                            icon="el-icon-fa-pencil-square-o"
                            size="small"
                            type="text"
                            @click="edit(scope.row.id)"
                        />
                    </el-tooltip>

                    <el-tooltip
                        v-if="hasRoleToDelete"
                        :content="$t('table.delete')"
                        placement="top"
                    >
                        <el-button
                            icon="el-icon-fa-trash"
                            size="small"
                            type="text"
                            @click="destroy(scope.row)"
                        />
                    </el-tooltip>
                </template>
            </el-table-column>
        </el-table>

        <div class="mt-3">
            <el-pagination
                style="float: right"
                @size-change="(args) => pager.pageSizeChange(args)"
                :current-page.sync="pager.currentPage"
                :layout="paginationLayout"
                :total="pager.filteredAndSortedList(list).length"
                background
            ></el-pagination>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import _ from "underscore";

export default {
    name: "app-document-import",
    
    computed: {
        ...mapGetters({
            loading: "entities/document/loading",
            list: "entities/document/list",
            pager: "entities/document/pager",
            hasRoleToDelete: "entities/document/hasRoleToDelete",
            hasRoleToUpdate: "entities/document/hasRoleToUpdate",
            hasRoleToRead: "entities/document/hasRoleToRead",
            hasRoleToReadLogs: "entities/document/hasRoleToReadLogs",
            hasRoleToCreate: "entities/document/hasRoleToCreate",
            isClubManager: "entities/document/isClubManager",
            isMobile: "shared/isMobile",
            paginationLayout: "shared/paginationLayout"
        })
    },

    filters: {
        capitalize: function(str) {
            return str.charAt(0).toUpperCase() + str.slice(1);
        }
    },

    created() {
        this.$store.dispatch("entities/document/list");
    },

    beforeRouteLeave(to, from, next) {
        this.$store.dispatch("entities/document/clear");
        next();
    },

    beforeRouteUpdate(to, from, next) {
        this.$store.dispatch("entities/document/list");
        next();
    },

    methods: {
        create() {
            this.$router.push({
                name: "documentNew"
            });
        },

        rowClick(row, column, cell, event) {
            if (cell.label != this.$t("table.actions")) {
                this.$router.push({
                    name: "documentShow",
                    params: { id: row.id }
                });
            }
        },

        show(id) {
            this.$router.push({
                name: "documentShow",
                params: { id }
            });
        },

        edit(id) {
            this.$router.push({
                name: "documentEdit",
                params: { id }
            });
        },

        importCsv() {
            this.$router.push({
                name: "documentImportCsv"
            });
        },

        destroy(model) {
            this.$confirm(
                this.$t("table.areYouSure"),
                this.$t("table.confirm"),
                {
                    confirmButtonText: this.$t("table.yes"),
                    cancelButtonText: this.$t("table.no"),
                    type: "warning"
                }
            )
                .then(() =>
                    this.$store.dispatch("entities/document/destroy", model)
                )
                .catch(() => {});
        }, 
    }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/entities/document/document-list.vue?6a049b7c